<div class="service-reschedule">
  <div class="service-reschedule__header">
    <span class="service-reschedule__header__title">Reprogramar servicio</span>
    <button mat-icon-button (click)="closeDialog()" data-testid="service-reschedule-close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="service-reschedule__container">
    @if (data.availableReschedule) { @if (serviceRescheduleState.isLoading()) {
    <div class="service-reschedule__loading" data-testid="service-reschedule-loading">
      <app-horus-loading size="S"></app-horus-loading>
    </div>
    } @else if (serviceRescheduleState.hasError()) {
    <div class="service-reschedule__message" data-testid="service-reschedule-error">
      <app-horus-message-general
        nameIcon="errorMessageIcon"
        btnAction="INTENTAR NUEVAMENTE"
        (action)="serviceRescheduleState.refetchSchedules()"
      >
        <span class="error-title">Lo sentimos</span><br />
        Hubo un <strong>error al intentar cargar</strong> las fechas
        disponibles.
      </app-horus-message-general>
    </div>
    } @else if (serviceRescheduleState.isLoaded()) {
    <form [formGroup]="rescheduleServiceForm" class="service-reschedule__body" data-testid="service-reschedule-form">
      <div class="service-reschedule__container_v2">
        <div class="service-reschedule__observations">
          <h3 class="service-reschedule__section-title">Información general</h3>
          <div class="observations__header">
            <mat-icon fontSet="material-icons-outlined">note_alt</mat-icon>
            <span>OBSERVACIONES</span>
          </div>
          <textarea
            class="observations__textarea"
            placeholder="Escribe aquí..."
            formControlName="observations"
          ></textarea>
        </div>
        <div class="service-reschedule__time-section">
          <h3 class="service-reschedule__section-title">Rango Horario</h3>
          <div class="service-reschedule__radio-group">
            @for (timeRange of timeRanges; track timeRange.value) {
            <label 
              class="service-reschedule__radio-option"
              [attr.data-testid]="'service-reschedule-time-' + timeRange.value"
            >
              <input 
                type="radio" 
                [value]="timeRange.value"
                formControlName="rescheduleTime"
                class="service-reschedule__radio-input"
              />
              <span class="service-reschedule__radio-label">{{ timeRange.label }}</span>
            </label>
            }
          </div>
        </div>
        <div class="service-reschedule__content">
          <h3 class="service-reschedule__section-title">Nueva fecha</h3>
          <mat-button-toggle-group
            formControlName="rescheduleDate"
            class="service-reschedule__dates"
            [hideSingleSelectionIndicator]="true"
            appearance="legacy"
            data-testid="service-reschedule-dates-group"
          >
            @for (schedule of serviceRescheduleState.visibleSchedules(); track
            schedule) {
            <mat-button-toggle
              class="service-reschedule__dates__button"
              [value]="schedule"
              [attr.data-testid]="'service-reschedule-date-' + schedule"
            >
              {{ schedule | availableDatePipe }}
            </mat-button-toggle>
            }
          </mat-button-toggle-group>

          @if (serviceRescheduleState.hasMoreSchedules()) {
          <div class="service-reschedule__see-more">
            @if (serviceRescheduleState.isShowingAllSchedules()) {
            <button
              class="service-reschedule__see-more__button"
              mat-button
              (click)="serviceRescheduleState.showLessSchedules()"
              data-testid="service-reschedule-show-less-btn"
            >
              <mat-icon>calendar_today</mat-icon>
              Ver menos fechas
            </button>
            } @else {
            <button
              class="service-reschedule__see-more__button"
              mat-button
              (click)="serviceRescheduleState.showMoreSchedules()"
              data-testid="service-reschedule-show-more-btn"
            >
              <mat-icon>calendar_today</mat-icon>
              Ver más fechas
            </button>
            }
          </div>
          }
        </div> 
      </div>
    </form>
    <div class="service-reschedule__footer">
      <div class="service-reschedule__footer__options">
        <button
          horusBtn
          class="w-full"
          horusBtnSize="md"
          [disabled]="
            !serviceRescheduleState.canReschedule() ||
            rescheduleServiceForm.invalid
          "
          (click)="rescheduleService()"
          data-testid="service-reschedule-submit-btn"
        >
          REPROGRAMAR SERVICIO
        </button>

        <button
          horusBtn
          class="w-full"
          horusBtnVariant="outline-default"
          horusBtnSize="md"
          (click)="closeDialog()"
          data-testid="service-reschedule-cancel-btn"
        >
          CANCELAR
        </button>
      </div>
    </div>
    } @else {
    <div class="service-reschedule__message" data-testid="service-reschedule-no-dates">
      <app-horus-message-general
        nameIcon="noDataMessageIcon"
        btnAction="INGRESAR TICKET"
        (action)="redirectToAria()"
      >
        <span class="warning-title">No hay fechas disponibles</span><br />
        <span
          >No se encontraron
          <strong>fechas disponibles para reprogramar</strong> este
          servicio.</span
        >
      </app-horus-message-general>
    </div>
    } } @else {
    <div class="service-reschedule__message" data-testid="service-reschedule-not-allowed">
      <app-horus-message-general
        nameIcon="noDataMessageIcon"
        btnAction="INGRESAR TICKET"
        (action)="redirectToAria()"
      >
        <span class="warning-title">No podemos ejecutar la acción</span><br />
        <span
          >Este servicio
          <strong>no cumple las condiciones para ser reprogramado</strong
          >.</span
        >
      </app-horus-message-general>
    </div>
    }
  </div>
</div>
